import React from 'react'

// css
import 'assets/style/elements/hash-tag.scss'

function Element({ className = '', data = [], border = true, block = true, hasShap = false, onClick = () => {} }) {
  if ([false, 'false'].includes(border)) {
    className += ' borderless'
  }
  // tag-list or
  return (
    <div className={`${block ? 'hash-tag-wrap' : 'tag-list'} ${className}`}>
      {data && data.length > 0 ? (
        data
          .filter((i) => i || i.trim())
          .map((item, index) =>
            block ? (
              <span key={`hashtag_${index}`} className="hash-tag" onClick={() => onClick(item)}>
                {hasShap ? '#' + item : item}
              </span>
            ) : (
              '#' + item.trim() + ' '
            ),
          )
      ) : (
        <span>&nbsp;</span>
      )}
    </div>
  )
}

export default Element
